import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * MyHomeCloudログインダイアログ
 */
class LoginDialog extends Dialog {
    callBack: Function;

    /**
     * コンストラクタ
     */
    constructor(draggable) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'loginDialog';
      // タイトル
      let title: string;
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = 'ログイン'; break;
        default: title = 'Login'; break;
      }

      let contents = '<div class="dialogLoginDialog">\n';
      contents += '<p class="linkChangeDialog"><a href="#"><span class="jp">新規登録する方はこちら</span><span class="en">Sign up</span></a></p>\n';
      contents += '<div class="tableBox">\n';
      contents += '<p class="notationMessage"><span class="jp">メールアドレスとパスワードを入力して下さい。</span><span class="en">Please input your e-mail and password.</span></p>\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<th><span class="jp">メールアドレス：</span><span class="en">e-mail</span></th><td><input class="loginInput" type="text" id="input_login" maxlength="100"></td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<th><span class="jp">　パスワード：</span><span class="en">password</span></th><td><input class="loginInput" type="password" id="input_password" maxlength="30"></td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '<p class="dialogInlineError"  id="dialogLoginDialogError"></p>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      let footer = '<button id="btnDoneLogin" value="1"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button value="0"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
      this.createDialog(id, title, contents, footer);

      // イベント設定
      this.viewObj.querySelectorAll('button').forEach((element) => {
        element.addEventListener('click', this.onFooterBtnClicked);
      });
      this.viewObj.querySelectorAll('a').forEach((element) => {
        element.addEventListener('click', this.onTextlinkClicked);
      });

      if (marietta.webcad.WebCADGlobal.language === 'jp') {
        document.getElementById('dialogLoginDialogError').style.width = '420px';
      }
      document.querySelectorAll('.loginInput').forEach((elem) => {
        elem.addEventListener('keydown', (e) => {
          e.stopImmediatePropagation();
        });
      });
    }

    /**
        * linkChangeDialogがクリックされた
        */
    onTextlinkClicked = (e) => {
      e.preventDefault();
      const tarDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SignupDialog) as marietta.webcad.view.dialog.SignupDialog;
      tarDialog.callBack = this.callBack;
    }

    /**
     * フッターのボタンがクリックされた
     */
    onFooterBtnClicked = (e) => {
      e.preventDefault();

      if (Number((e.currentTarget).value)) {
        // エラーメッセージの初期化
        document.getElementById('dialogLoginDialogError').innerHTML = '';

        const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.base_url + marietta.webcad.net.default.param.default.ActionName.LOGIN;
        let data = `email=${(<HTMLInputElement>document.getElementById('input_login')).value}&password=${(<HTMLInputElement>document.getElementById('input_password')).value}`;
        // eslint-disable-next-line no-undef
        data += `&fuel_csrf_token=${fuel_csrf_token()}`;
        const self = this;

        const headers = {
          Accept: 'application/json',
        };
        fetch(url, {
          method: 'POST',
          body: data,
          headers,
        }).then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.json();
          }
          throw Error(response.statusText);
        }).then((info) => {
          // ログイン済み
          if (info.error === undefined) {
            // アクティベーションチェック
            self.onLoginSuccess();
          } else if (info.error.message.indexOf('／') !== -1 || info.error.message.indexOf('/') !== -1) {
            // エラーメッセージの初期化
            let splitmessage: any[];
            if (info.error.message.indexOf('／') !== -1) {
              splitmessage = info.error.message.split('／');
            } else if (info.error.message.indexOf('/') !== -1) {
              splitmessage = info.error.message.split('/');
            }
            document.getElementById('dialogLoginDialogError').innerHTML = `${splitmessage[0]}<br>${splitmessage[1]}`;
          } else {
            document.getElementById('dialogLoginDialogError').innerHTML = info.error.message;
          }
        }).catch(() => {
          // エラーメッセージの初期化
          switch (marietta.webcad.WebCADGlobal.language) {
            case 'en': document.getElementById('dialogLoginDialogError').innerHTML = ' Error: Cannot find connection. Please check your network.'; break;
            default: document.getElementById('dialogLoginDialogError').innerHTML = '通信エラー:ネットワーク環境をご確認ください。'; break;
          }
        });
      } else {
        // webcadを閉じるフラグをおろす
        marietta.webcad.WebCADGlobal.webcad2Dmanager.closeWebcadAfterEvent = false;

        // ダイアログを閉じる
        marietta.webcad.WebCADGlobal.removeDialog();
      }
    }

    /**
       * ログイン成功した
       * （ログインIDの取得）
       */
    onLoginSuccess = () => {
      // ログインIDの取得
      const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.base_url + marietta.webcad.net.default.param.default.ActionName.GET_USER_INFO;
      // eslint-disable-next-line no-undef
      const data = `fuel_csrf_token=${fuel_csrf_token()}`;
      const self = this;

      const headers = {
        Accept: 'application/json',
      };
      fetch(url, {
        method: 'GET',
        body: data,
        headers,
      }).then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        }
        throw Error(response.statusText);
      }).then((info) => {
        // ログインＩＤの保持
        marietta.webcad.WebCADGlobal.webcad2Dmanager.userID = info.data.id;
        // アクティベーションチェック後、次の処理を行う
        marietta.webcad.WebCADGlobal.activatableCheck(() => {
          self.activatableCheckSuccess();
        });
      }).catch((msg: any) => {
        // ログインエラー
        console.log('ログインエラー');
        console.log(msg);
        // IDが取得できない場合は、アクティベーションチェックもせずに、そのまま続行
        if (self.callBack != null) {
          self.callBack();
        }
        this.close();
      });
    }

    /**
       * アクティベーションチェック完了
       */
    activatableCheckSuccess(): void {
      if (this.callBack != null) {
        this.callBack();
      }
      this.close();
    }
}

export default LoginDialog;
